const SHARE_CACHE_NAME = "share-target-incoming";
const SHARE_CACHE_KEY = "/share-target/pending-file";

/**
 * Reads back the file stashed by sw.ts's share-target handler, if any.
 * Call once on startup; the query param set by the SW redirect is the
 * only signal that a share just happened.
 */
export async function consumePendingSharedFile(): Promise<File | null> {
  if (!new URLSearchParams(location.search).has("shared")) return null;
  history.replaceState(null, "", location.pathname);

  if (!("caches" in window)) return null;
  const cache = await caches.open(SHARE_CACHE_NAME);
  const response = await cache.match(SHARE_CACHE_KEY);
  if (!response) return null;
  await cache.delete(SHARE_CACHE_KEY);

  const blob = await response.blob();
  const name = decodeURIComponent(response.headers.get("X-File-Name") ?? "shared.walk");
  return new File([blob], name, { type: blob.type });
}
